module.exports = __webpack_public_path__ + "static/media/BM_Admin.98055d25.svg";